import { render, staticRenderFns } from "./new-room.vue?vue&type=template&id=17d4831a&scoped=true&"
import script from "./new-room.vue?vue&type=script&lang=js&"
export * from "./new-room.vue?vue&type=script&lang=js&"
import style0 from "./new-room.vue?vue&type=style&index=0&id=17d4831a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4831a",
  null
  
)

export default component.exports